<template>
  <CommonModal @onClose="onClose" :title="modalData.name">
    <template #body>
      <div :class="$style.container">
        <div :class="$style.content">
          <div :class="$style.list">
            <div
              v-for="item in modalData.activities"
              :key="item.id"
              @click="setTab(modalData.id, item.name, item.id)"
              :class="[
                $style.item,
                { [$style.active]: activeTab.item === item.name },
              ]"
            >
              <div :class="$style.radio">
                <div :class="$style.decor"></div>
              </div>
              {{ item.name }}
            </div>
          </div>
        </div>
      </div>
    </template>
  </CommonModal>
</template>

<script>
import CommonModal from "@/components/modals/CommonModal.vue";
export default {
  components: {
    CommonModal,
  },
  props: {
    modalData: Object,
    activeTab: Object,
  },
  methods: {
    onClose() {
      this.$store.commit("setIconsModals", {
        modal: "activity",
        value: false,
      });
    },
    setTab(category, item, id) {
      this.$emit("setTab", { category, item, id });
      this.$store.commit("setIconsModals", {
        modal: "activity",
        value: false,
      });
    },
  },
};
</script>

<style lang="scss" module>
.container {
  .content {
    margin: 1rem 0 0 0;
    .list {
      .item {
        transition: all 0.3s ease-in-out;
        cursor: pointer;
        display: flex;

        align-items: start;
        gap: 0.625rem;
        margin: 0 0 0.75rem 0;
        &:last-child {
          margin: 0;
        }
        &.active {
          position: relative;
          left: -0.45rem;
          font-weight: 700;
          .radio {
            position: relative;
            top: -0.125rem;
            left: 0.125rem;
            display: flex;
            align-items: center;
            justify-content: center;
            flex: 0 0 1.5rem;
            width: 1.5rem;
            height: 1.5rem;
            background-color: #321fd53d;
            border-radius: 50%;
            border: none;
            .decor {
              width: 1rem;
              height: 1rem;
              background-color: #386ed2;
              border-radius: 50%;
              border: 1px solid #386ed2;
            }
          }
        }
        .radio {
          position: relative;
          top: 0.125rem;
          flex: 0 0 1rem;
          width: 1rem;
          height: 1rem;
          background-color: $bg-white;
          border-radius: 50%;
          border: 1px solid $black;
        }
      }
    }
  }
}
</style>
